import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import ResourceFileUploader from '../../../components/QuestionBank/ResourceFileUploader';
import ResourceFileTable from '../../../components/QuestionBank/ResourceFileTable';
import { fetchResourceFiles } from 'redux/ResourceFiles/ResourceFilesAction';

const ResourceFilesPage = ({ fetchResourceFiles, activeSpecialty }) => {
  // Refetch whenever the admin switches specialty — the collection changes with it
  useEffect(() => {
    fetchResourceFiles();
  }, [fetchResourceFiles, activeSpecialty]);

  return (
    <>
      <div className="header bg-gradient-success pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            <h1 className="text-white mb-0">Files &amp; Downloads</h1>
            <p className="text-white mt-0 mb-0">
              Upload and manage downloadable files such as Anki decks and guides
            </p>
          </div>
        </Container>
      </div>

      <Container className="mt--7" fluid>
        <Row>
          <Col xl="12">
            <ResourceFileUploader />
            <ResourceFileTable />
          </Col>
        </Row>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => ({
  activeSpecialty: state.specialty.activeSpecialty,
});

export default connect(mapStateToProps, { fetchResourceFiles })(ResourceFilesPage);
